import React from 'react'
import dayjs from 'dayjs'
import T from 'ramda/es/T'
import cond from 'ramda/es/cond'
import ReactCalendar from 'react-calendar'
import { Paper } from '@material-ui/core'

import './Calendar.css'

const modultransBlockDate = dayjs('06-01-2020', "MM-DD-YYYY")

export const CalendarBase = ({
  classes,
  date,
  selectDate,
  view,
  onClickMonth,
  dateRange,
  isPricesPage,
  isAlimanDispatcher,
  routeType,
  isModultransPartner,
  ...other
}) => {
  const value = isPricesPage
    ? dateRange
    : date

  function isRouteFromUa() {
    return routeType === "ua"
  }

  function isRouteFromCz() {
    return routeType === "cz"
  }

  function handleUaRoute(date) {
    return date.getDay() !== 4 && date.getDay() !== 5
  }

  function handleCzRoute(date) {
    return date.getDay() !== 6 && date.getDay() !== 0
  }

  function handleEmptyRoute(date) {
    return date.getDay() !== 4
      && date.getDay() !== 5
      && date.getDay() !== 6
      && date.getDay() !== 0
  }

  function handleDateDisabled({ date }) {
    if (isAlimanDispatcher) {
      return cond([
        [isRouteFromUa, handleUaRoute],
        [isRouteFromCz, handleCzRoute],
        [T, handleEmptyRoute]
      ])(date)
    }

    if (isModultransPartner) {
      return dayjs(date).isBefore(modultransBlockDate)
    }

    return false
  }

  return (
    <Paper className={classes.paper}>
      <ReactCalendar
        view={view}
        value={value}
        onChange={selectDate}
        className={classes.calendar}
        onClickMonth={onClickMonth}
        tileDisabled={handleDateDisabled}
        {...other}
      />
    </Paper>
  )
}

CalendarBase.defaultProps = {
  view: 'month'
}




// WEBPACK FOOTER //
// ./src/components/Calendar/Calendar.js